/**
 * Auth API calls.
 *
 * All paths are relative (/api/...) so the Vite dev proxy or
 * CloudFront origin behaviour routes them to the real API.
 */

export interface MeResponse {
  customerId: string;
  email: string;
}

export async function authStart(email: string): Promise<{ ok: true }> {
  const res = await fetch('/api/auth/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    throw new Error(`Auth start failed: ${res.status}`);
  }

  return { ok: true };
}

/**
 * Fetch the current authenticated user from the session cookie.
 * Returns null if not authenticated (401).
 */
export async function getMe(): Promise<MeResponse | null> {
  const res = await fetch('/api/me', {
    method: 'GET',
    credentials: 'include',
  });

  if (res.status === 401) {
    return null;
  }

  if (!res.ok) {
    throw new Error(`GET /api/me failed: ${res.status}`);
  }

  return res.json();
}
